import addressSchema from 'forms/addressSchema'

const organisationSchema = function(state, props) {

  const uiSchema = {
    "name" : {
      "ui:options": {
        width: 6
      }
    },
    "email" : {
      "ui:options": {
        width: 6
      }
    },
    "organisationType" : {
      "ui:widget": "select",
      "ui:options": {
        width: 4,
        selectOptions: ['bvba', 'vzw', 'eenmanszaak', 'vof','nv', 'commnv', 'commva', 'cvba', 'cvoa'].map((key) => { return {key: key, value: key, text: I18n.t(`api.forms.organisation.organisation_types.${key}`) }})
      }
    },
    ...addressSchema(state,props),
  }

  return uiSchema
}

export default organisationSchema;

